const orange_rdc_voccabulaire = {
  category: {
    en: "Category",
    fr: "Catégorie",
  },
  objet: {
    en: "Subject",
    fr: "Objet",
  },
  reason: {
    en: "Reason",
    fr: "Raison",
  },
  sub_reason: {
    en: "Reason",
    fr: "Raison",
  },
  reason_need: {
    en: "Reason",
    fr: "Raison",
  },
  sub_reason_need: {
    en: "Reason",
    fr: "Raison",
  },
  category_reclamation: {
    en: "Reclamation",
    fr: "Reclamation",
  },
  category_demandes: {
    en: "Requests",
    fr: "Demandes",
  },
  category_others: {
    en: "Others",
    fr: "Autres",
  },
};

export default orange_rdc_voccabulaire;
